var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"wrapper"},[_c('RouterLink',{attrs:{"to":"/"}},[_c('img',{staticClass:"header-logo",attrs:{"src":require("@/assets/logo.svg"),"alt":"logo"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }